// ─── Local account auth (demo-grade, client-side) ───────────────────────
const AUTH_KEY = 'roocad_auth_users';
const SESSION_KEY = 'roocad_session';

const loadUsers = () => { try { return JSON.parse(localStorage.getItem(AUTH_KEY) || '{}'); } catch { return {}; } };
const saveUsers = (u) => localStorage.setItem(AUTH_KEY, JSON.stringify(u));
const hash = (p) => btoa(unescape(encodeURIComponent(p + '::roocad')));

export function createUser(email, password) {
    const users = loadUsers();
    if (!email || !email.includes('@')) return { ok: false, error: 'Enter a valid email address.' };
    if (users[email.toLowerCase()]) return { ok: false, error: 'An account with that email already exists.' };
    users[email.toLowerCase()] = { email: email.toLowerCase(), hash: hash(password), created: Date.now() };
    saveUsers(users);
    return { ok: true };
}

export function authenticate(email, password) {
    const user = loadUsers()[email.toLowerCase()];
    if (!user || user.hash !== hash(password)) return { ok: false, error: 'Invalid email or password.' };
    localStorage.setItem(SESSION_KEY, JSON.stringify({ email: user.email, at: Date.now() }));
    return { ok: true, email: user.email };
}

export function resetPassword(email, newPassword) {
    const users = loadUsers();
    const user = users[email.toLowerCase()];
    if (!user) return { ok: false, error: 'No account found with that email.' };
    user.hash = hash(newPassword);
    saveUsers(users);
    return { ok: true };
}

export function changeCredentials(email, newEmail, newPassword) {
    const users = loadUsers();
    const user = users[email.toLowerCase()];
    if (!user) return { ok: false, error: 'Current account not found.' };
    if (newEmail && newEmail.toLowerCase() !== email.toLowerCase()) {
        if (users[newEmail.toLowerCase()]) return { ok: false, error: 'That email is already in use.' };
        delete users[email.toLowerCase()];
        user.email = newEmail.toLowerCase();
        users[user.email] = user;
    }
    if (newPassword) user.hash = hash(newPassword);
    saveUsers(users);
    localStorage.setItem(SESSION_KEY, JSON.stringify({ email: user.email, at: Date.now() }));
    return { ok: true, email: user.email };
}

export function getSession() {
    try { const s = JSON.parse(localStorage.getItem(SESSION_KEY) || 'null'); return s && s.email ? s : null; } catch { return null; }
}
export function logout() { localStorage.removeItem(SESSION_KEY); }
export function seedOwnerAccount() {
    const users = loadUsers();
    if (!users['dcfarkas94@gmail.com']) createUser('dcfarkas94@gmail.com', '@Casefark0394');
}